import styled from 'styled-components';

export const StyledColumn = styled.div`
width: ${props => props.w ?? 10}%;
text-align: right;
`
